import React, { useEffect, useState } from "react";
import Icon from "../icons/Icon";
import styles from "./ScrollToTopButton.module.css";

const SHOW_AFTER_PX = 420;

// TODO(content): the accessible name — the button is icon-only.
const LABEL = "Scroll to top";

function ScrollToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setIsVisible(window.scrollY > SHOW_AFTER_PX);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  const handleClick = () => {
    // Lenis owns the scroll position when it is mounted; going straight to
    // window.scrollTo would fight it and leave the two out of sync.
    if (window.__lenis) {
      window.__lenis.scrollTo(0);
      return;
    }

    /* Lenis is absent exactly when the visitor asked for reduced motion (App.js
       never creates it then), so this fallback must not animate either. */
    const prefersReduced =
      typeof window.matchMedia === "function" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    window.scrollTo({ top: 0, behavior: prefersReduced ? "auto" : "smooth" });
  };

  return (
    /* The global 44px box (.btn .btn--box), paper-filled by the module.
       data-surface, never data-tone: data-tone is the Header's signal and
       belongs to Sections only. */
    <button
      type="button"
      className={`btn btn--box ${styles.scrollTopBtn} ${isVisible ? styles.show : ""}`}
      aria-label={LABEL}
      aria-hidden={isVisible ? undefined : "true"}
      tabIndex={isVisible ? 0 : -1}
      data-surface="paper"
      onClick={handleClick}
    >
      <Icon name="chevron-down" size={20} className={styles.scrollTopIcon} />
    </button>
  );
}

export default ScrollToTopButton;
